import React, { useEffect, useMemo, useReducer, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { enumUtil } from "../../utils/Enum";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import { TabActionCaregiver } from "../../actions/CaregiverActions";
import 'react-data-grid/lib/styles.css';
import Loader from "../shared/Loader/Loader";
import { useSelector } from "react-redux";
import { Alphbets } from "../../utils/Constants";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css'; // theme css file
import Table from "../Setup/Shared/Table";
import GridColumnHeader from "../Setup/Shared/GridColumnHeader"
import { CaregiverRecordAction } from "../../actions/CaregiverActions";
import { isNull } from "lodash";
import SearchHeader from "../Setup/Shared/SearchHeader";
import OpenQuickPopup from "../shared/OpenQuickPopup/OpenQuickPopup";
import SuperSearchList from "../shared/SuperSearch/SuperSearchList";
import { Modal } from "react-bootstrap";
import ModalHeader from "../Setup/Shared/ModalHeader";
import DataGrid from 'react-data-grid';
import CalendaRangeInput from "../General/CalendarRangeInput";
import handleCopyText from "../shared/CopyData";
import CustomUseRef from "../shared/DropDown/CustomUseRef";
import AmountFormatter from "../../utils/AmountFormatter";
import NotificationHandler from "../../utils/NotificationHandler";
import ContentReceiver from "../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";
import { FindFirstChild } from "../../utils/FindMenuOption";
import SuperSearchMultipleClient from "../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";

const CaregiverSearch = (props) => {
    let isEditAllowed = FindFirstChild('CareGiver', 'Demographics')?.ISView

    const API_URL_PATIENT = enumUtil.controller.PATIENT
    const API_URL_GENERAL = enumUtil.controller.General
    let dispatch = useDispatch();
    const [filterShow, setFilterShow] = useState(false);
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    const [caregiverData, setCaregiverData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [popup, setPopup] = useState(<></>);
    const [IsFilterApplied, setIsFilterApplied] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    const [addselect2, setaddselect1] = useState(false);
    const [reloadSuperSearchPatient, setReloadSuperSearchPatient] = useState(false);

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    ///Search///
    const Search_Data = {
        "SearchLetter": "",
        "SearchCeriteria": "",
        // "InsuranceID": "",
        "LocationID": "-1",
        // "ProviderID": "-1",
        "Date": null
    }
    const searchButton = {
        AddNew: true,
        Excel: true,
        PDF: true,
        Delete: false,
        Filter: true,
        View: false  // set true if want to display cards as well
    }
    const [searchParam, setSearchParam] = useState(Search_Data)
    const [openTab, setOpenTab] = useState('')
    const [searchLoad, setSearchLoad] = useState(false)
    const [selectedInsurance, setSelectedInsurance] = useState('')
    //For Pagination
    const [PerPage, setPerPage] = useState(10);
    const [PageNo, setPageNo] = useState(1);
    const [TotalPages, setTotalPages] = useState();
    const handlePageClick = (page) => { setPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }
    ///////////
    const AddNewCaregiver = () => {
        let dataObj = {
            key: 2,
            name: "Caregiver",
            active: true,
            data: {
                name: "New Caregiver",
                id: -1,
                time: new Date()
            },
        };
        props.TabActionCaregiver(dataObj);
    }
    const LoadData = (searchParam) => {
        if (isEditAllowed) {
            setIsLoading(true);
            setCaregiverData([])
            ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
                "TableName": enumUtil.enumAPITableName.Caregiver,
                "SearchCriteria": searchParam,
                "PerPage": PerPage,
                "PageNo": PageNo,
            })
                .then((response) => {
                    setIsLoading(false);
                    handleGridHeader({ defaultData: response.Rows })
                    setCaregiverData(response.Rows)
                    setTotalPages(response.count.NumOfPages);
                    let CaregiverData = [];
                    CaregiverData = response.Rows.map((item, index) => {
                        let newlist = { ID: item.CareGiverID, name: item.FirstName, FullName: item.FirstName + ', ' + item.LastName + ', ' + item.AccountNumber }
                        return newlist;

                    })
                    dispatch(CaregiverRecordAction(CaregiverData))
                }).catch((error) => {
                    console.log("ERROR", error)
                    // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                    setCaregiverData([])
                    setIsLoading(false);
                })
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setSearchParam({ ...searchParam, SearchCeriteria: e.target.value })
            SearchByParam(searchParam)
        }
    }
    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const handleApply = () => {
        setIsFilterApplied(true)
        if (!isNull(searchParam)) {
            setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    useEffect(() => {
        setIsLoading(true);
        setCaregiverData([])
        LoadData(searchParam)
    }, [PerPage, PageNo, searchLoad]) //seacrhParam
    useEffect(() => { props.setRecordsNum(caregiverData.length) }, [caregiverData])

    const OpenCaregiver = (data) => {
        let obj = {
            key: 2,
            name: "Caregiver",
            active: true,
            data: {
                id: data.CareGiverID,
                name: data.LastName,
                time: new Date(),
            },
        };
        props.TabActionCaregiver(obj);
    }
    const OpenCaregiverDetails = (data, type) => {
        console.log("TYPE", type)
        let obj = {
            key: 2,
            name: "Caregiver",
            active: true,
            data: {
                id: data.CareGiverID,
                name: data.FirstName,
                time: new Date(),
                type: type,
            },
        };
        props.TabActionCaregiver(obj);
    }
    /////// viewAllClaims ///////
    const handleViewAllClaim = (PatID, PatName) => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    CareGiverID: PatID,
                    CaregiverName: PatName,
                },
            },
        };
        setOpenTab(dataObj)
    }
    const OpenQuickPopupMemoized = ({ row, setPopup, name }) => {
        const memoizedPopup = useMemo(() => {
            if (name === 'Insurance') {
                return (
                    <OpenQuickPopup ID={row.PrimaryInsuranceID} name={row.PrimaryInsurance} setPopup={setPopup} popupName={name} />);
            }
        }, []);

        return memoizedPopup;
    };
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns =
        [
            {
                width: 80,
                name: '',
                renderCell({ row }) {
                    return (
                        <div className="d-flex align-items-center pat_claim">
                            <span className='demographic' onClick={() => OpenCaregiverDetails(row, "Demographics")}>
                                <i className="icon-Demographics-icon "></i>
                                <p class="tool_tip xsm_text text-light">Demographics</p>
                            </span>
                            {/* <span className='insurance' onClick={() => OpenCaregiverDetails(row, "Insurances")}>
                                <i className="icon-umbrella-solid"></i>
                                <p class="tool_tip xsm_text text-light">Insurances</p>
                            </span> */}
                            <span className='claim' onClick={() => handleViewAllClaim(row.CareGiverID + "", row.FirstName + ' ' + row.LastName,)}>
                                <span class="icon-pateintclaim fs-15"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
                                <p class="tool_tip xsm_text text-light">Claims</p>
                            </span>
                        </div>
                    );
                },
            },
            {
                key: 'AccountNumber',
                width: 120,
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-location'} headerName={'Account#'} sortIcon={true} type={'number'} colKey={'AccountNumber'} data={caregiverData} setData={setCaregiverData} />),
                resizable: true,
                renderCell({ row }) {
                    return (
                        <>
                            {row.AccountNumber}
                            <button className="btn btn-link w-100">

                                <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                                    <div className="validation_message" onClick={() => OpenCaregiver(row)}>{row.CareGiverID} </div>
                                    <div className="icon_copy">
                                        {/* <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopyText(row.AccountNumber)}></i>  */}
                                        {/* <p class="tool_tip xsm_text text-light">Copy</p> */}
                                    </div>
                                </div>
                            </button>
                            <div className="circles">
                                {row.CaregiverValidation === 'True' ? <span className="green_circle"></span> : <span className="red_circle"></span>}
                                <div className='missing_detail'>
                                    <div className='demo missing_data'>
                                        <span className='d-flex align-items-center'>
                                            <span class="icon-Group-4785"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                            Demographic have some data missing <span className='detail border-0'>
                                                <i className='cursor-pointer icon-Icon-metro-cross'></i>
                                            </span>
                                        </span>
                                        <div className='message_list'>
                                            <p className='text'>{row.CaregiverErrorMessages}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <button
                        className="table-btn" onClick={() => OpenCaregiver(row)}>
                        {row.FirstName}{' '}{row.LastName}
                    </button> */}
                        </>
                    );
                },
            },
            // {
            //     key: 'Profile',
            //     name: (<GridColumnHeader iconName={'icon-umbrella-solid'} headerName={'Profile'} sortIcon={false}/>),
            //     resizable: true,
            //     renderCell({ row }
            //     ) {
            //         return (
            //             <>
            //                 {/* <button
            //                 className="table-btn" onClick={() => OpenCaregiver(row)}>
            //                 {row.AccountNumber}
            //             </button> */}
            //                 {/* {row.FirstName === 'Taimoor' ? <i className="icon-male-icon"></i> : <i className="icon-female-icon"></i>}
            //             <button
            //                 className="table-btn" onClick={() => OpenCaregiver(row)}>
            //                 {row.FirstName}{' '}{row.LastName}
            //             </button> */}
            //                 {/* <div className="circles">
            //                     {row.Completed === 'true' ?
            //                         <span className="green_circle"></span>
            //                         :
            //                         <span className="red_circle">
            //                         </span>   
            //                     }
            //                          <div className='missing_detail'>
            //                         <div className='demo missing_data'>
            //                             <span className='d-flex align-items-center'>
            //                                 <img src={demoicon}></img>
            //                                 Demographic have some data missing <span className='detail border-0'>
            //                                     <i className='cursor-pointer icon-Icon-metro-cross'></i>
            //                                     </span>
            //                             </span>
            //                             <div className='message_list'>
            //                                 <p className='text'>Caregiver Address is missing.</p>
            //                                 <p className='text'>Caregiver DOB is missing.</p>
            //                                 <p className='text'>Caregiver Address is missing.</p>
            //                             </div>
            //                         </div>
            //                         </div>
            //                 </div> */}
            //             </>
            //         );
            //     }
            // },
            {
                key: 'LastName',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-material-date-range'} headerName={'Last Name'} sortIcon={true} type={'string'} colKey={'LastName'} data={caregiverData} setData={setCaregiverData} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                <div className="copy_icon validation_message" title={row.LastName}>
                                    {row.LastName}
                                </div>
                                {row.LastName && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.CareGiverID, row.LastName)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.CareGiverID}-${row.LastName}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </>
                    );
                },
            },
            {
                key: 'FirstName',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-material-date-range'} headerName={'First Name'} sortIcon={true} type={'string'} colKey={'FirstName'} data={caregiverData} setData={setCaregiverData} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                <div className="copy_icon validation_message" title={row.FirstName}>
                                    {row.FirstName}
                                </div>
                                {row.FirstName && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.CareGiverID, row.FirstName)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.CareGiverID}-${row.FirstName}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </>
                    );
                },
            },
            {
                key: 'DateOfBirth',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-material-date-range'} headerName={'DOB'} sortIcon={true} type={'date'} colKey={'DateOfBirth'} data={caregiverData} setData={setCaregiverData} />),
                resizable: true,
            },
            {
                key: 'SSN',
                name: (<GridColumnHeader iconName={'icon-umbrella-solid'} headerName={'SSN'} sortIcon={false} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                <div className="copy_icon validation_message" title={row.SSN}>
                                    {row.SSN}
                                </div>
                                {row.SSN && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.CareGiverID, row.SSN)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.CareGiverID}-${row.SSN}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </>
                    );
                },
            },
            {
                key: 'Status',
                name: (<GridColumnHeader iconName={'icon-umbrella-solid'} headerName={'Status'} sortIcon={false} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                                <div className="copy_icon validation_message">
                                    <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Insurance'} />
                                    {/* <OpenQuickPopup ID={row.PrimaryInsuranceID} name={row.PrimaryInsurance} setPopup={setPopup} popupName={'Insurance'} /> */}
                                </div>
                            </div>
                            {/* <div className="circles">
                                {row.CaregiverInsuranceValidation === 'True' ? <span className="green_circle"></span> : <span className="red_circle"></span>}
                                <div className='missing_detail'>
                                    <div className='demo missing_data'>
                                        <span className='d-flex align-items-center'>
                                            <img src={demoicon}></img>
                                            Demographic have some data missing <span className='detail border-0'>
                                                <i className='cursor-pointer icon-Icon-metro-cross'></i>
                                            </span>
                                        </span>
                                        <div className='message_list'>
                                            <p className='text'>{row.CaregiverInsuranceErrorMessages}</p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </>
                    );
                },
            },
            {
                key: 'Discipline',
                name: (<GridColumnHeader iconName={'icon-umbrella-solid'} headerName={'Discipline'} sortIcon={false} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (<>{row.Discipline}</>)
                }
            }
        ];
    ////Search Letters////
    const handleSearchByAlphabet = (e) => {
        setSearchParam({
            SearchLetter: e, SearchCeriteria: "", InsuranceID: null, LocationID: null,
            ProviderID: null, Date: null
        })
        setSearchLoad(searchLoad => !searchLoad)
    }
    const handleNextAlphabet = () => {
        if (searchParam.SearchLetter === 'Z') {
            setSearchParam({ ...searchParam, SearchLetter: 'A' })
        } else {
            setSearchParam({ ...searchParam, SearchLetter: String.fromCharCode(searchParam.SearchLetter.charCodeAt(0) + 1) });
        }
        setSearchLoad(searchLoad => !searchLoad)
    }
    const handlePreviousAlphabet = () => {
        if (searchParam.SearchLetter === 'A') {
            setSearchParam({ ...searchParam, SearchLetter: 'Z' });
        } else {
            setSearchParam({ ...searchParam, SearchLetter: String.fromCharCode(searchParam.SearchLetter.charCodeAt(0) - 1) });
        }
        setSearchLoad(searchLoad => !searchLoad)
    }
    const clearFilter = () => {
        setIsFilterApplied(false)
        setSearchParam({
            SearchLetter: "", SearchCeriteria: "", InsuranceID: "",
            ProviderID: "-1", Date: null
        })
        setReloadSuperSearchPatient(!reloadSuperSearchPatient);
        setSelectedInsurance('')
        setFilterShow(false)
    }
    const rowClass = () => { return "row-bg" }
    const [is, setIs] = useState(false);

    const columnsAll = [
        { key: 'Account', name: 'Account #' },
        { key: 'Name', name: 'Name' },
        { key: 'DOB', name: 'Date of Birth' },
        { key: 'Insured', name: 'Insured' },
        { key: 'BalanceDuePat', name: 'Balance due Pat.' },
        { key: 'AccountPhone', name: 'Account Phone' },
    ]

    const rowsAll = [
        { "Account": "3129831298", "Name": "Alex", "DOB": "04/19/2017", "Insured": "", "BalanceDuePat": "1234", "AccountPhone": "1234567890" },
    ]

    const patientHeader = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '15px' }}>Caregiver Search</p>;
    };
    const closeDropdown = () => {
        setFilterShow(false)

    };
    const handleFilterOpen = (e) => {
        setFilterShow(!filterShow)
        e.stopPropagation();

    }
    const handleSelectedData = (selectedData, name, type) => {
        if (type === 'client' && !isNull(selectedData)) {
            if (name === "InsuranceID" && !isNull(selectedData)) {
                setSearchParam({ ...searchParam, SearchLetter: null, InsuranceID: String(selectedData.value) });
                setSelectedInsurance(selectedData.display);
            }
            if (name === "ProviderID" && !isNull(selectedData)) {
                // setProviderID(selectedData.value + "")
            }
            if (name === "RefProviderID" && !isNull(selectedData)) {
                // setRefProviderID(selectedData.value + "")
            }
        } else if (type === 'server' && !isNull(selectedData)) {

        } else {

        }

        return selectedData
    }
    return (
        <>
            {popup}
            {/* <div className='p-2 pt-1 pb-0'> */}
            {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
            {/* <div className='alphabetic-filter m-auto'>
                    <button className='refresh active'>
                        <i className="icon-Icon-awesome-sync-alt" onClick={() => handleSearchByAlphabet(null)}></i>
                    </button>
                    <button>
                        <i className='icon-angle-left' onClick={handlePreviousAlphabet}></i>
                    </button>
                    <div className='alphabetics'>
                        {/* <span value={searchParam} >{searchParam}</span> */}
            {/* {Alphbets.map((type) => {
                            return (
                                <span className={type.value === searchParam.SearchLetter ? 'active' : ''} onClick={() => handleSearchByAlphabet(type.value)} key={type.value}>{type.value}</span>
                            )
                        })}
                    </div>
                    <button>
                        <i className='icon-right-direction' onClick={handleNextAlphabet}></i>
                    </button> */}
            {/* </div> */}
            {/* </div> */}
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between gap-1 align-items-end">
                    <div className="row row-half row-gap-15 flex-grow-1">
                        <div className="col-lg-3">
                            <div className="input">
                                <label className="hs-patient-label">Name</label>
                                <input type="text" className="form-control fc-xs rounded"
                                    placeholder="Search by name, ssn, or Insured id…"
                                    value={searchParam.SearchCeriteria}
                                    onChange={e => setSearchParam({ ...searchParam, SearchLetter: null, SearchCeriteria: e.target.value })}
                                    onKeyDown={SearchOnEnter}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 multipleSearch-rounded">
                            <div className="input race">
                                <label className="hs-patient-label">Location</label>
                                <SuperSearchMultipleClient
                                    key={reloadSuperSearchPatient}
                                    id="LocationID"
                                    name="LocationID"
                                    selectedOptionsDisplay='Location'
                                    initialSelectedValues={[]}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    options={DropdownData.Location?.filter(item => !['-1', -1].includes(item.value))}
                                    sup_btn="sup_btn-Inp"
                                    sup_inp="superSearchVisitInp"
                                />
                            </div>
                        </div>
                        {/* <div className="col-lg-3">
                            <div className="input">
                                <label className="hs-patient-label">Location</label>
                                <select className="form-control fc-xs rounded" id='LocationID' name='LocationID' placeholder="Select" value={searchParam.LocationID}
                                    onChange={(e) => setSearchParam({ ...searchParam, SearchLetter: null, LocationID: e.target.value || null })}>
                                    {DropdownData.Location?.map((e, index) => (
                                        <option value={e.value} key={index}>
                                            {e.display}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div> */}
                        <div className="col-lg-3">
                            <div className="input">
                                <label className="hs-patient-label">Status</label>
                                <select className="form-control fc-xs rounded" id='Status' name='Status' placeholder="Select" value={searchParam.Status}
                                    onChange={(e) => setSearchParam({ ...searchParam, SearchLetter: null, Status: e.target.value || null })}>
                                    {[]?.map((e, index) => (
                                        <option value={e.value} key={index}>
                                            {e.display}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        {/* <div className="col-md-3">
                            <div className='input simple_select position-relative'>
                                <label className="hs-patient-label">Insurance</label>
                                <SuperSearchList
                                    type="client"
                                    id='InsuranceID'
                                    name='InsuranceID'
                                    searchValue={selectedInsurance ? selectedInsurance : searchParam.InsuranceID}
                                    data={DropdownData.Insurance}
                                    onChange={(e) => setSearchParam({ ...searchParam, SearchLetter: null, InsuranceID: e.target.value || null })}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_simple_btn'
                                    sup_inp='sup_simple_Inp'
                                    className="form-control rounded"
                                />
                            </div>
                        </div> */}
                        {/* <div className="col-lg-3">
                            <div className="input">
                                <label className="hs-patient-label">Insurance</label>
                                <select className="form-control fc-xs rounded" id='InsuranceID' name='InsuranceID' value={searchParam.InsuranceID}
                                    onChange={(e) => setSearchParam({ ...searchParam, SearchLetter: null, InsuranceID: e.target.value || null })}>
                                    {DropdownData.Insurance?.map((e, index) => (
                                        <option value={e.value} key={index}>
                                            {e.display}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div> */}
                        <div className="col-lg-3 d-flex align-items-end position-relative">
                            <div className="d-flex align-items-center gap-10">
                                <div className="align-items-baseline d-flex gap-10">
                                    <button className={isEditAllowed ? 'btn btn-orange btn-xs no-width rounded me-3' : 'btn btn-orange btn-xs no-width rounded me-3 disabled'} onClick={SearchByParam}>Search</button>
                                    {/* <button className='btn btn-orange btn-xs no-width rounded' onClick={SearchByParam}>Search</button> */}
                                    <button className='btn btn-outline btn-xs no-width rounded' onClick={clearFilter}>Clear</button>
                                </div>
                                {/* <i className="fs-20 icon-Group-7973 mt-0-5" onClick={() => setaddselect1(!addselect2)}></i> */}
                                {addselect2 &&
                                    <div className="ar_attention-popup">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <p className="heading">Attention Please</p>
                                            <i className="icon-Icon-metro-cross fs-12"></i>
                                        </div>
                                        <div className="d-flex gap-10 mb-10">
                                            <div className="large">
                                                <div className="alert-content">
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <i className="fs-20 icon-Group-7973 fs-16"></i>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <p className="text">Missing Legal Documents</p>
                                                            <p className="heading clr-danger">1</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="small">
                                                <div className="alert-content">
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <i className="fs-20 icon-Group-7973 fs-16"></i>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <p className="text">Missing Address</p>
                                                            <p className="heading clr-danger">4</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="small">
                                                <div className="alert-content">
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <i className="fs-20 icon-Group-7973 fs-16"></i>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <p className="text">Medical Required</p>
                                                            <p className="heading clr-danger">7</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex gap-10 ">
                                            <div className="large">
                                                <div className="alert-content">
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <i className="fs-20 icon-Group-7973 fs-16"></i>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <p className="text">Missing Legal Documents</p>
                                                            <p className="heading clr-danger">1</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="small">
                                                <div className="alert-content">
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <i className="fs-20 icon-Group-7973 fs-16"></i>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <p className="text">Missing Address</p>
                                                            <p className="heading clr-danger">4</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <SearchHeader
                        AddNew={AddNewCaregiver}
                        Filter={handleFilterOpen}
                        FilterClass={IsFilterApplied}
                        searchButton={searchButton}
                        Key={21}
                        tableName={enumUtil.enumAPITableName.Caregiver}
                        Name={'CaregiverSearch'}
                        searchParam={{ ...searchParam, IsExcelExport: "1" }}
                        PerPage={PerPage}
                        PageNo={PageNo}
                        TotalPages={TotalPages}
                        isEmpty={caregiverData.length > 0}

                    />
                </div>
            </div>
            {isLoading ? <Loader /> : null}
            <div className=" patient_filter position-relative">
                <Table
                    columns={columns}
                    rows={caregiverData}
                    // rows={[{AccountNumber:'1',CareGiverID:'1',FirstName:'Caregiver1',},
                    // {AccountNumber:'2',CareGiverID:'2',FirstName:'Caregiver2',},
                    // {AccountNumber:'3',CareGiverID:'3',FirstName:'Caregiver3',}]}
                    height='465px'
                    rowClass={rowClass}
                    dynamicClass='fill-grid DataGrid-Table hk-exp-table  all_patient one-row-with-tab'
                    rowHeight={25}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    Key={21}
                    Name={'CaregiverSearch'}
                    isLoading={isLoading}
                    hideColClass='responses-hide'
                    TableName={'Caregiver'}
                    colPopup='top-0'
                />
                <div className={`sidebar-filters ${filterShow && 'active'}`}>
                    <div className="sidebar-filters__heading">
                        <span>Filters</span>
                        <button className="btn btn-transparent" onClick={clearFilter}>
                            <i className="bi bi-x"></i>
                        </button>
                    </div>
                    <hr />
                    <div className="sidebar-filters__body">
                        {/* <div className="input filters-field">
                            <label>Provider</label>
                            <select className="form-control fc-xs" id='ProviderID' name='ProviderID' placeholder="Select" value={searchParam.ProviderID}
                                onChange={(e) => setSearchParam({ ...searchParam, SearchLetter: null, ProviderID: e.target.value || null })}>
                                {DropdownData.Provider?.map((e, index) => (
                                    <option value={e.value} key={index}>
                                        {e.display}
                                    </option>
                                ))}
                            </select>
                        </div> */}
                        {/* <hr /> */}
                        {/* <div className="input filters-field">
                            <label>Location</label>
                            <select className="form-control fc-xs" id='LocationID' name='LocationID' placeholder="Select" value={searchParam.LocationID}
                                onChange={(e) => setSearchParam({ ...searchParam, SearchLetter: null, LocationID: e.target.value || null })}>
                                {DropdownData.Location?.map((e, index) => (
                                    <option value={e.value} key={index}>
                                        {e.display}
                                    </option>
                                ))}
                            </select>
                        </div> */}
                        <div className="input filters-field">
                            <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['Entry Date']} />
                        </div>
                    </div>
                    <div className="sidebar-filters__footer">
                        <button className="btn btn-orange" onClick={handleApply}>Apply</button>
                    </div>
                </div>
            </div>

            {/* Caregiver Search Modal */}
            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg master_list_modal ar_palceholder">
                <Modal.Body>
                    <SearchHeader />
                    <ModalHeader HeaderName={patientHeader} DeletePopup={""} isClosed={() => { }} key={631} Name={'SwitchPractice'} />
                    <div className='container-fluid  br-clr'>
                        <div className="row">
                            <div className="col-12 mb-2 ">
                                <div className="input">
                                    <div className='input-group hk-input-search'>
                                        <input type="text" className='form-control fc-xs'
                                            placeholder='Search by name, DOB, account #, phone #'
                                        // onChange={e => setSearchParam(e.target.value)}
                                        // onKeyDown={SearchOnEnter} 
                                        />
                                        <span className="input-group-text" id="basic-addon2">
                                            <i className="bi bi-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading">Recently Opened</p>
                                    <DataGrid
                                        columns={columnsAll}
                                        headerRowHeight={25}
                                        rowHeight={25}
                                        rows={rowsAll}
                                        className="all_audit fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                                    />
                                </div>
                            </div>
                            <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">Search</button>
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_close">Cancel</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

function mapStateToPropss(state) {
    return {
        OpenDynamicTab: state.Open_Caregiver_Tab ? state.Open_Caregiver_Tab : [],
    };
}

const action = {
    TabActionCaregiver,
};

export default connect(mapStateToPropss, action)(CaregiverSearch);
